import { useState } from 'react';

export default function BomTable({ components, onUpdate, editable }) {
  const [editingIdx, setEditingIdx] = useState(null);
  const [editRow, setEditRow] = useState({});

  const startEdit = (idx) => {
    setEditingIdx(idx);
    setEditRow({ ...components[idx] });
  };

  const saveEdit = () => {
    const updated = [...components];
    updated[editingIdx] = editRow;
    onUpdate(updated);
    setEditingIdx(null);
  };

  const deleteRow = (idx) => {
    onUpdate(components.filter((_, i) => i !== idx));
  };

  const addRow = () => {
    onUpdate([...components, { name: 'New Component', material: '', quantity: 1, unit: 'pieces', estimated_cost_usd: 0, notes: '' }]);
    setEditingIdx(components.length);
    setEditRow({ name: 'New Component', material: '', quantity: 1, unit: 'pieces', estimated_cost_usd: 0, notes: '' });
  };

  const totalCost = components.reduce((sum, c) => sum + (c.estimated_cost_usd || 0) * (c.quantity || 1), 0);

  return (
    <div>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-vault-border">
              <th className="text-left py-2 px-3 text-xs font-medium text-gray-500 uppercase">Component</th>
              <th className="text-left py-2 px-3 text-xs font-medium text-gray-500 uppercase">Material</th>
              <th className="text-right py-2 px-3 text-xs font-medium text-gray-500 uppercase">Qty</th>
              <th className="text-left py-2 px-3 text-xs font-medium text-gray-500 uppercase">Unit</th>
              <th className="text-right py-2 px-3 text-xs font-medium text-gray-500 uppercase">Unit Cost</th>
              <th className="text-right py-2 px-3 text-xs font-medium text-gray-500 uppercase">Line Total</th>
              {editable && <th className="py-2 px-3 w-20"></th>}
            </tr>
          </thead>
          <tbody>
            {components.map((comp, idx) => (
              editingIdx === idx ? (
                <tr key={idx} className="border-b border-vault-border bg-yellow-50">
                  <td className="py-2 px-3">
                    <input value={editRow.name || ''} onChange={e => setEditRow({ ...editRow, name: e.target.value })}
                      className="w-full px-2 py-1 border border-vault-border rounded text-sm" />
                  </td>
                  <td className="py-2 px-3">
                    <input value={editRow.material || ''} onChange={e => setEditRow({ ...editRow, material: e.target.value })}
                      className="w-full px-2 py-1 border border-vault-border rounded text-sm" />
                  </td>
                  <td className="py-2 px-3">
                    <input type="number" value={editRow.quantity || 1} onChange={e => setEditRow({ ...editRow, quantity: parseFloat(e.target.value) || 1 })}
                      className="w-16 px-2 py-1 border border-vault-border rounded text-sm text-right" />
                  </td>
                  <td className="py-2 px-3">
                    <input value={editRow.unit || ''} onChange={e => setEditRow({ ...editRow, unit: e.target.value })}
                      className="w-20 px-2 py-1 border border-vault-border rounded text-sm" />
                  </td>
                  <td className="py-2 px-3">
                    <input type="number" step="0.01" value={editRow.estimated_cost_usd || 0}
                      onChange={e => setEditRow({ ...editRow, estimated_cost_usd: parseFloat(e.target.value) || 0 })}
                      className="w-20 px-2 py-1 border border-vault-border rounded text-sm text-right" />
                  </td>
                  <td className="py-2 px-3 text-right text-gray-500">
                    ${((editRow.estimated_cost_usd || 0) * (editRow.quantity || 1)).toFixed(2)}
                  </td>
                  <td className="py-2 px-3">
                    <div className="flex gap-1">
                      <button onClick={saveEdit} className="text-green-600 hover:text-green-800 text-xs font-medium">Save</button>
                      <button onClick={() => setEditingIdx(null)} className="text-gray-400 hover:text-gray-600 text-xs">Cancel</button>
                    </div>
                  </td>
                </tr>
              ) : (
                <tr key={idx} className="border-b border-vault-border hover:bg-gray-50">
                  <td className="py-2 px-3 font-medium text-vault-navy">{comp.name}</td>
                  <td className="py-2 px-3 text-gray-500">{comp.material}</td>
                  <td className="py-2 px-3 text-right text-gray-600">{comp.quantity}</td>
                  <td className="py-2 px-3 text-gray-500">{comp.unit}</td>
                  <td className="py-2 px-3 text-right text-gray-600">${(comp.estimated_cost_usd || 0).toFixed(2)}</td>
                  <td className="py-2 px-3 text-right font-medium text-vault-navy">
                    ${((comp.estimated_cost_usd || 0) * (comp.quantity || 1)).toFixed(2)}
                  </td>
                  {editable && (
                    <td className="py-2 px-3">
                      <div className="flex gap-2">
                        <button onClick={() => startEdit(idx)} className="text-vault-gold hover:text-vault-gold-dark text-xs font-medium">Edit</button>
                        <button onClick={() => deleteRow(idx)} className="text-gray-300 hover:text-vault-error text-xs">&times;</button>
                      </div>
                    </td>
                  )}
                </tr>
              )
            ))}
          </tbody>
          <tfoot>
            <tr className="border-t-2 border-vault-border">
              <td colSpan={5} className="py-2 px-3 text-right font-semibold text-vault-navy">Component Total</td>
              <td className="py-2 px-3 text-right font-bold text-vault-navy">${totalCost.toFixed(2)}</td>
              {editable && <td />}
            </tr>
          </tfoot>
        </table>
      </div>

      {editable && (
        <button onClick={addRow} className="mt-3 text-sm text-vault-gold hover:text-vault-gold-dark font-medium">
          + Add Component
        </button>
      )}
    </div>
  );
}
